import React, { useState } from "react";
import { Form, Input, Button, Typography, Modal } from "antd";
import icon from "../assets/img/forgotPassword.png";
import wave from "../assets/img/waveSvgg.svg";
import { useNavigate } from "react-router-dom";
import "./ResetPassword.css";
import kapinsightsLogo from "../assets/img/kapinsightsLogoo.png";
import { toast } from "react-toastify";
import Changed from "../assets/img/changedPass.png";
import { Spin } from "antd";
import { post } from "../utils/apiUtils";
import { PASSWORD_REQUIREMENTS, PASSWORD_RULES } from "../utils/passwordRules";
import { useTranslation } from "react-i18next";

const { Title, Paragraph } = Typography;

const ResetPassword: React.FC = () => {
  const { t } = useTranslation("auth");
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const onFinish = async (values: any) => {
    setLoading(true);
    const { token, newPassword } = values;

    try {
      const response = await post<any>(
        `Users/reset-password/?token=${token}&new_password=${newPassword}`
      );

      if (response.type === "success") {
        setTimeout(() => toast.success(t("resetPassword.successToast")), 0);
        setTimeout(() => {
          setLoading(false);
          setIsModalVisible(true);
        }, 4000);
      } else {
        const apiErrorResponse = response.data?.response?.data;
        toast.error(
          apiErrorResponse?.detail ||
            apiErrorResponse?.message ||
            t("resetPassword.failedToast")
        );
        setLoading(false);
      }
    } catch (error: any) {
      console.error("Error resetting password:", error);
      if (error.response) {
        console.error(error.response.data);
        console.error(error.response.status);
      }
      setLoading(false);
    }
  };

  const handleCancelForm = () => {
    form.resetFields();
    navigate("/forgot-password");
  };

  const handleOk = () => {
    setIsModalVisible(false);
    navigate("/");
  };

  return (
    <div className="reset-password-container">
      <div className="kapinsightsLogo">
        <img src={kapinsightsLogo} alt="kapinsights logo" />
      </div>
      <div className="container reset-password-content">
        <img src={icon} alt="reset password" className="resetPassImg" />
        <div className="reset-password-form-container">
          <Title level={2} className="title reset-your-password-title">
            {t("resetPassword.title")}
          </Title>
          <p className="password-instructions">
            {t("resetPassword.instructions")}
            <ul>
              {PASSWORD_REQUIREMENTS.map((req) => (
                <li key={req}>{req}</li>
              ))}
            </ul>
          </p>
          {loading ? (
            <Spin size="large" />
          ) : (
            <Form name="reset_password" form={form} onFinish={onFinish}>
              <Typography className="password">{t("resetPassword.newPassword")}</Typography>
              <Form.Item name="newPassword" rules={PASSWORD_RULES}>
                <Input.Password
                  placeholder={t("resetPassword.passwordPlaceholder")}
                  style={{ height: "44px" }}
                  className="password-input"
                />
              </Form.Item>
              <Typography className="password">{t("resetPassword.token")}</Typography>
              <Form.Item
                name="token"
                rules={[
                  { required: true, message: t("resetPassword.tokenRequired") },
                ]}
              >
                <Input
                  placeholder={t("resetPassword.tokenPlaceholder")}
                  style={{ height: "44px" }}
                />
              </Form.Item>
              <Form.Item className="buttons-footer">
                <Button
                  htmlType="submit"
                  className="reset-password-form-button"
                >
                  {t("resetPassword.resetButton")}
                </Button>
                <Button
                  htmlType="button"
                  onClick={handleCancelForm}
                  className="cancel-form-button"
                >
                  {t("resetPassword.cancelButton")}
                </Button>
              </Form.Item>
            </Form>
          )}
        </div>
      </div>
      <div>
        <img src={wave} alt="wave" className="wave" />
      </div>

      <Modal
        title={null}
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleOk}
        footer={[
          <Button key="submit" onClick={handleOk} className="got-it-button">
            {t("resetPassword.gotIt")}
          </Button>,
        ]}
        style={{ width: "670px" }}
        wrapClassName="custom-modal"
      >
        <img src={Changed} alt="Email sent" className="modal-image" />
        <h2 className="email-title">{t("resetPassword.modalTitle")}</h2>
      </Modal>
    </div>
  );
};

export default ResetPassword;
